// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // 导入路由配置
import { Popup } from 'vant';
import 'vant/lib/index.css';

const app = createApp(App)

app.use(router) // 使用路由
.use(Popup)

app.mount('#app')